/**
 * Error Surface Component
 * Provides consistent error UI with optional retry functionality
 */
import React from 'react';

function ErrorCard({
  message = 'Something went wrong',
  onRetry = null,
  retrying = false,
  style = {}
}) {
  return (
    <div
      style={{
        padding: '24px',
        background: '#fff',
        borderRadius: '8px',
        border: '3px solid #d4af37',
        boxShadow: '0 2px 8px rgba(212, 175, 55, 0.15)',
        textAlign: 'center',
        ...style
      }}
    >
      {/* Error Icon */}
      <div
        style={{
          fontSize: '3rem',
          marginBottom: '16px',
          color: '#ff5252'
        }}
      >
        
      </div>

      {/* Error Message */}
      <div
        style={{
          fontSize: '1.1rem',
          fontWeight: '600',
          color: '#333',
          marginBottom: onRetry ? '20px' : '8px',
          lineHeight: '1.5'
        }}
      >
        {message}
      </div>

      {/* Optional Retry Button */}
      {onRetry && (
        <button
          onClick={onRetry}
          disabled={retrying}
          style={{
            padding: '12px 32px',
            background: retrying ? '#ccc' : '#d4af37',
            color: retrying ? '#999' : '#1a1a1a',
            border: 'none',
            borderRadius: '4px',
            cursor: retrying ? 'not-allowed' : 'pointer',
            fontWeight: '700',
            fontSize: '1rem',
            transition: 'transform 0.2s, box-shadow 0.2s',
            boxShadow: retrying ? 'none' : '0 2px 4px rgba(0, 0, 0, 0.1)'
          }}
          onMouseOver={(e) => {
            if (!retrying) {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.15)';
            }
          }}
          onMouseOut={(e) => {
            if (!retrying) {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
            }
          }}
        >
          {retrying ? 'Retrying...' : 'Try Again'}
        </button>
      )}

      {/* Helper Text */}
      {!onRetry && (
        <div
          style={{
            fontSize: '0.85rem',
            color: '#666',
            fontStyle: 'italic'
          }}
        >
          Please refresh the page or contact support if this persists.
        </div>
      )}
    </div>
  );
}

export default ErrorCard;
